<script setup lang="ts">
import { useTranslation } from 'i18next-vue'
import { useAppStore } from '@/stores/AppStore'
import type { DepositType } from '@/type/Appointment'
import { getDepositTypeDisplayName } from '@/composables/Appointment/useDepositTypes'

// บริการที่สนใจของ LINE OA (LMP-7840) - รายการ / ชื่อมาจากการตั้งค่าที่ POS - เลือกได้ 1 (ส่ง id กลับให้ฟอร์ม)
interface Props {
  show: boolean
  depositTypes: DepositType[]
  selectedDepositTypeId: number | null
}

interface Emits {
  (e: 'selectType', id: number): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()
const { t } = useTranslation()
const appStore = useAppStore()
</script>

<template>
  <van-cell-group v-if="show" class="group-container" inset>
    <p style="font-weight: bold; padding: 10px 15px; font-size: 18px">
      {{ t('appointmentrequest.interest_service') }}
      <span style="font-weight: normal; font-size: small; color: gray">
        {{ t('single_select_hint') }}
      </span>
    </p>
    <!-- LINE OA ยังไม่ได้ตั้งบริการ - บอกให้ติดต่อคลินิก ไม่ปล่อยกล่องว่าง (บังคับเลือก จะส่งนัดไม่ได้) -->
    <p v-if="depositTypes.length === 0" style="padding: 0 15px 15px; color: gray">
      {{ t('appointmentrequest.deposit_type.empty') }}
    </p>
    <!-- ชื่อบริการตั้งเองได้ จำนวน / ความยาวไม่แน่นอน - ปุ่มขึ้นแถวใหม่ได้ และชื่อยาวขึ้นบรรทัดใหม่ในปุ่ม
         (van-button small สูงตายตัว 32px - ต้อง height auto ไม่งั้นข้อความล้นปุ่ม) -->
    <div v-else style="display: flex; flex-wrap: wrap; gap: 10px; padding: 10px">
      <van-button
        v-for="depositType in depositTypes"
        :key="depositType.id"
        v-bind="{
          type: selectedDepositTypeId === depositType.id ? 'primary' : 'default',
          size: 'small',
        }"
        style="height: auto; min-height: 32px; padding-top: 4px; padding-bottom: 4px"
        @click.prevent="emit('selectType', depositType.id)"
      >
        {{ getDepositTypeDisplayName(depositType, appStore.language) }}
      </van-button>
    </div>
  </van-cell-group>
</template>

<style scoped>
.group-container {
  margin: 15px 0px;
  border: 2px solid #c8c9cc;
  border-radius: 20px;
}
</style>
